import PropTypes from 'prop-types';
import { tileShape, tileDefaultProps } from './tile';
import { responsiveVideoType } from './video';

export const cardShape = {
  ...tileShape,
  classNames: PropTypes.shape({
    caption: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    copy: PropTypes.string,
  }),
  copy: PropTypes.string,
  imageClassName: PropTypes.string,
  format: PropTypes.oneOf(['portrait', 'landscape']).isRequired,
  formats: PropTypes.shape({
    portrait: PropTypes.number.isRequired,
    landscape: PropTypes.number.isRequired,
  }),
  video: responsiveVideoType,
};

export const cardDefaultProps = {
  ...tileDefaultProps,
  classNames: {},
  copy: undefined,
  formats: {
    portrait: 4 / 5,
    landscape: 4 / 3,
  },
  video: undefined,
};

export const cardType = PropTypes.shape(cardShape);
